import axios from 'axios';
import { BASE_URL } from './helpers';

export interface CreditsBalance {
  user_id: string;
  balance: number;
  reserved: number;
  daily_limit: number;
  is_admin: boolean;
}

export interface LedgerRow {
  id: string;
  user_id: string;
  user_username?: string | null;
  kind: 'grant' | 'hold' | 'release' | 'debit' | 'adjust';
  delta: number;
  pipeline_run_id: string | null;
  checkpoint_id: string | null;
  attempt: number;
  provider: string | null;
  model: string | null;
  cost_usd: number | null;
  cost_source: string | null;
  note: string | null;
  admin_user_id: string | null;
  admin_username?: string | null;
  created_at: string;
}

export interface GrantCreditsRequest {
  user_id?: string;
  username?: string;
  amount_credits: number;
  note?: string;
}

export interface GrantCreditsResponse {
  status: string;
  user_id?: string;
  username?: string;
  amount_credits: number;
}

export interface LedgerQuery {
  user_id?: string;
  username?: string;
  since?: string;
  limit?: number;
}

async function getMyBalance(): Promise<CreditsBalance> {
  const res = await axios.get<CreditsBalance>(`${BASE_URL}/users/me/credits`);
  return res.data;
}

async function grant(req: GrantCreditsRequest): Promise<GrantCreditsResponse> {
  const res = await axios.post<GrantCreditsResponse>(`${BASE_URL}/admin/credits/grant`, req);
  return res.data;
}

async function getLedger(query: LedgerQuery = {}): Promise<LedgerRow[]> {
  const res = await axios.get<LedgerRow[]>(`${BASE_URL}/admin/credits/ledger`, { params: query });
  return res.data;
}

const CreditsAPI = { getMyBalance, grant, getLedger };

export default CreditsAPI;
